import {
  ContractorPackage,
  ContractorPackageLineItem,
} from "@interfaces/contractorPackage";
import {
  decodePackageSocialCommitment,
  encodePackageSocialCommitment,
} from "./commitment";
import { getImageUrl } from "@hooks/utils/useUpload";

export const decodeContractorPackage = async (
  contractorPackage: ContractorPackage
): Promise<ContractorPackageLineItem> => {
  const presignedUrl =
    contractorPackage.organisation_logo.length > 0
      ? await getImageUrl(contractorPackage.organisation_logo)
      : "";
  return {
    id: contractorPackage.contractor_package_id,
    projectId: contractorPackage.project_id,
    contractorId: contractorPackage.contractor_id,
    contractorName: contractorPackage.organisation_name,
    representativeEmail: contractorPackage.representative_email,
    contractorLogo: presignedUrl,
    startDate: new Date(contractorPackage.start_date),
    endDate: new Date(contractorPackage.end_date),
    totalPackageValue: contractorPackage.total_package_value,
    packageMargin: contractorPackage.package_margin,
    specialisedEquipmentValue: contractorPackage.specialised_equipment_value,
    deemedLabourRatio: contractorPackage.deemed_labour_ratio,
    deemedLabourHourlyRate: contractorPackage.deemed_labour_hourly_rate,
    requiredHours: contractorPackage.required_hours,
    requiredSpend: contractorPackage.required_spend,
    variations: contractorPackage.variations,
    created: new Date(contractorPackage.created),
    commitments: contractorPackage.commitments.map((s) =>
      decodePackageSocialCommitment(s)
    ),
  };
};

export const encodeContractorPackage = (
  contractorPackage: ContractorPackageLineItem
): ContractorPackage => {
  return {
    contractor_package_id: contractorPackage.id,
    contractor_id: contractorPackage.contractorId,
    organisation_name: contractorPackage.contractorName,
    organisation_logo: contractorPackage.contractorLogo,
    representative_email: contractorPackage.representativeEmail,
    project_id: contractorPackage.projectId,
    start_date: contractorPackage.startDate,
    end_date: contractorPackage.endDate,
    created: contractorPackage.created,
    total_package_value: contractorPackage.totalPackageValue,
    package_margin: contractorPackage.packageMargin,
    specialised_equipment_value: contractorPackage.specialisedEquipmentValue,
    deemed_labour_ratio: contractorPackage.deemedLabourRatio,
    deemed_labour_hourly_rate: contractorPackage.deemedLabourHourlyRate,
    required_hours: contractorPackage.requiredHours,
    required_spend: contractorPackage.requiredSpend,
    variations: contractorPackage.variations,
    send_invite: contractorPackage.sendInvite,
    commitments: contractorPackage.commitments.map((s) =>
      encodePackageSocialCommitment(s)
    ),
  };
};
